/**
 * Board provision action values returned by the ensure_user_boards job output.
 */
export enum BoardProvisionAction {
  CREATED = 'created',
  SKIPPED = 'skipped',
  FAILED = 'failed',
}
